import ImageCard from 'molecules/ImageCard/ImageCard';
import { ImageCardProps } from 'molecules/ImageCard/ImageCard';
import LeftAlignedCarousel from 'molecules/LeftAlignedCarousel/LeftAlignedCarousel';
import React from 'react';
import { ImageCardCarouselContainer } from './ImageCardCarousel.styles';
interface ImageCardCarouselProps {
  cards: ImageCardProps[];
}

const ImageCardCarousel = ({ cards }: ImageCardCarouselProps): JSX.Element => (
  <ImageCardCarouselContainer>
    <LeftAlignedCarousel>
      {cards.map((card, index) => (
        <ImageCard
          key={index}
          className='image-card-item'
          {...card}
        />
      ))}
    </LeftAlignedCarousel>
  </ImageCardCarouselContainer>
);

export default ImageCardCarousel;
